// T-129 (1) (v1.8.42, Session 39, 30.09.2026): Erstattungsweg im Storno-Dialog aus der jüngsten abgeschlossenen Online-Zahlung
// vorbelegen (bisher immer "Überweisung"). Quelle: api/payment/status/{id} (payments mit method und status, neueste zuerst).
// Reine Funktion, getestet in erstattungsweg.test.ts.

export type Erstattungsweg = 'bank' | 'card' | 'paypal';

interface ZahlungKurz {
  method?: unknown;
  status?: unknown;
  completedAt?: unknown;
}

/** Stripe/Kreditkarte/Apple Pay/Google Pay -> Karte (Review v1.8.42 Befund 7), PayPal -> PayPal, alles andere (Überweisung, Bar, Klarna, keine Zahlung) -> Überweisung. */
export function erstattungswegAus(zahlungen: unknown): Erstattungsweg {
  if (!Array.isArray(zahlungen)) return 'bank';
  const fertig = (zahlungen as ZahlungKurz[])
    .filter(z => z && String(z.status ?? '').toLowerCase() === 'completed')
    .sort((a, b) => String(b.completedAt ?? '').localeCompare(String(a.completedAt ?? '')));
  const m = String(fertig[0]?.method ?? '').toLowerCase();
  if (m === 'stripe' || m === 'kreditkarte' || m === 'applepay' || m === 'googlepay') return 'card';
  if (m === 'paypal') return 'paypal';
  return 'bank';
}
